import { useEffect, useRef } from 'react';
import { useSocket } from '../contexts/SocketContext';
import type { OnboardingSummary } from '../types/onboarding';
import type { SocketEventType } from '../types/socket';

export function useSocketEvent(
  event: 'connected',
  handler: (data: { userId: string }) => void
): void;
export function useSocketEvent(
  event: 'summary.ready',
  handler: (data: OnboardingSummary) => void
): void;
export function useSocketEvent(
  event: 'user.matches.ready',
  handler: (data: { userId: string; count: number; type: string }) => void
): void;
export function useSocketEvent(
  event: 'connect_error',
  handler: (error: Error) => void
): void;
export function useSocketEvent(
  event: 'disconnect',
  handler: (reason: string) => void
): void;
export function useSocketEvent<T = any>(
  event: SocketEventType,
  handler: (data: T) => void
): void {
  const { socket } = useSocket();
  const handlerRef = useRef(handler);

  // Keep handler ref up to date
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!socket) return;

    const wrappedHandler = (data: any) => handlerRef.current(data);
    socket.on(event, wrappedHandler);

    return () => {
      socket.off(event, wrappedHandler);
    };
  }, [socket, event]);
}
